import { ApiDefExporterApi } from './ApiDefExporterApi';
import { DiscoveryApi, IdentityApi } from '@backstage/core-plugin-api';
import { ExporterJsonResponse, ExporterPlatformResponse } from './types';
import { ResponseError } from './ResponseError';

export class ApiDefExporterClient implements ApiDefExporterApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly identityApi: IdentityApi;

  constructor(options: {
    discoveryApi: DiscoveryApi;
    identityApi: IdentityApi;
  }) {
    this.discoveryApi = options.discoveryApi;
    this.identityApi = options.identityApi;
  }

  async get(path: string): Promise<any> {
    const url = `${await this.discoveryApi.getBaseUrl('proxy')}${path}`;
    const { token: idToken } = await this.identityApi.getCredentials();
    const response = await fetch(url, {
      headers: idToken ? { Authorization: `Bearer ${idToken}` } : {},
    });

    if (!response.ok) {
      const body = response;
      const message = `Request failed with ${response.status} ${response.statusText}, ${body}`;
      throw new ResponseError(message, response);
    }

    const body = await response.json();
    return { status: response.status, body };
  }

  async getApiDefinition(url: string): Promise<ExporterJsonResponse> {
    const response = await this.get(url);
    return {
      body: response.body,
      status: response.status,
    };
  }

  async getPlatformList(url: string): Promise<ExporterPlatformResponse> {
    const response = await this.get(url);
    return {
      body: response.body,
      status: response.status,
    };
  }
}
